<template>
  <div class="bdoRadios">
    <div class="radio_box">
      <el-radio v-model="radio" label="1" text-color="#2E2E2E" border
        >BDO Unibank</el-radio
      >
    </div>
    <div class="radio_box">
      <el-radio v-model="radio" label="2" text-color="#2E2E2E" border
        >BDO Network Bank</el-radio
      >
    </div>
    <div class="radio_box">
      <el-radio v-model="radio" label="3" text-color="#2E2E2E" border
        >I don't have a BDO settlement account</el-radio
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "AccountType",
  // model: {
  //   prop: "toggleContact",
  //   event: "change",
  // },
  components: {},
  props: {
    value: {
      type: [Number, String],
      default: "",
    },
  },
  // inject:['bankTypeOne','bankTypeTwo','bankTypeThree'],
  data() {
    return {
      radio: "",
    };
  },
  watch: {
    radio: function (val) {
      this.$emit("input", val);
    },
    value: function (val) {
      this.radio = val || "";
    },
  },
  methods: {},
  // created() {
  //   console.log(this.$props)
  //   this.radio = this.$props.value;
  // },
};
</script>
<style lang="scss" scoped>
.bdoRadios {
  .left_box {
    width: 363px;
    margin-bottom: 152px;
  }
  .right_box {
    width: 363px;
    .form_item {
      margin-bottom: 16px;
      .input_name {
        font-family: Nunito;
        margin-bottom: 4px;
        color: #2e2e2e;
        font-size: 16px;
      }
    }
  }
  .title {
    font-family: Nunito;
    color: #2e2e2e;
    font-size: 16px;
  }
  .el-form-item__content {
    width: 100% !important;
  }
  .radio_box {
    .el-radio {
      color: #2e2e2e;
      height: 48px;
      padding: 13px 16px 0;
      line-height: 22px;
      width: 363px;
      border: 1px solid #99c1e7;
      border-radius: 8px;
      margin-right: -10px !important;
      margin-bottom: 8px;
      ::v-deep.el-radio__input {
        .el-radio__inner {
          border: 1px solid #99c1e7;
        }
        float: right;
        padding-top: 3px;
        &.is-checked .el-radio__inner {
          border-color: #0072d8;
          background: #ffffff;
          &::after {
            background-color: #0072d8;
          }
        }
        .is-checked .el-radio__inner {
          background: #fd7624 !important;
          border-color: #fd7624 !important;
        }
        ::after {
          width: 8px !important;
          height: 8px !important;
          background-color: #e4e4e4;
          transform: translate(-50%, -50%) scale(1);
        }
      }
      ::v-deep.el-radio__label {
        padding-left: 0px;
        font-size: 16px;
        color: #2e2e2e;
      }
    }
  }
}
</style>